<ion-header>

  <ion-toolbar color="marine">
    <ion-buttons slot="start">
      <ion-back-button text="" defaultHref="explore"></ion-back-button>
    </ion-buttons>
    <ion-title>Add card</ion-title>
  </ion-toolbar>

</ion-header>


<ion-content class="ion-padding">

  <div class="disclaimer-container">
    <ion-icon name="lock" color="green"></ion-icon>
    <p class="disclaimer">This information is secured by Stripe.</p>
  </div>

  <form #submitForm="ngForm" action="/" method="post" id="payment-form">

    <ion-item class="cardholder-name">
      <ion-input [(ngModel)]="fields.cardholderName" name="cardholderName" type="text" required placeholder="Cardholder name">
      </ion-input>
    </ion-item>

    <div class="form-row">
      <div id="card-element">
        <!-- a Stripe Element will be inserted here. -->
      </div>

      <!-- Used to display Element errors -->
      <div id="card-errors" role="alert"></div>
    </div>

    <ion-button outline large class="save-card-button" [disabled]="!submitForm.valid" (click)="submit()">Save Card</ion-button>

  </form>

</ion-content>